<template>
    <div class="w-full">
        <Bar  v-if="hasData"  class="w-full" :data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
   import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
    } from 'chart.js'
    import { Bar } from 'vue-chartjs'

    ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
    export default {
        props:['data'],
        name: 'DashboardVerticalBarChart',
        data(){
            return {}
        },
        computed:{
            monthLabels() {
                return [
                    this.$t("dashboard.auto.months.january"),
                    this.$t("dashboard.auto.months.february"),
                    this.$t("dashboard.auto.months.march"),
                    this.$t("dashboard.auto.months.april"),
                    this.$t("dashboard.auto.months.may"),
                    this.$t("dashboard.auto.months.june"),
                    this.$t("dashboard.auto.months.july"),
                    this.$t("dashboard.auto.months.august"),
                    this.$t("dashboard.auto.months.september"),
                    this.$t("dashboard.auto.months.october"),
                    this.$t("dashboard.auto.months.november"),
                    this.$t("dashboard.auto.months.december"),
                ];
            },
            chartData() {
                return {
                    labels: this.monthLabels,
                    datasets: this.data || [],
                };
            },
            chartOptions() {
                return {
                    responsive: true,
                    indexAxis: 'y',
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            title: {
                            display: false,
                                text: this.$t("dashboard.auto.chart_values")
                            }
                        },
                        x: {
                            title: {
                                display: false,
                                text: this.$t("dashboard.auto.chart_months")
                            }
                        }
                    }
                };
            },
            hasData() {
                return Array.isArray(this.data) && this.data.length > 0 && (this.data[0].data?.length ?? 0) > 0;
            },
        },
        components:{
            Bar
        },
        methods: {
        },
        
    }
</script>

<style lang="scss" scoped>

</style>
